import { CreatorLeaderboard } from "@/components/Creators/CreatorLeaderboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/leaderboard",
)({
  component: LeaderboardComponent,
  beforeLoad: () => ({
    title: "Leaderboard",
    headerTitle: "Creator Leaderboard",
    headerDescription: "See how you stack up against other creators.",
  }),
});

function LeaderboardComponent() {
  return (
    <div className="h-full w-full">
      <CreatorLeaderboard />
    </div>
  );
}
